import axios from "axios";
import { T } from "@/i18n/translations";

const OFFLINE = typeof window !== "undefined" && window.__KIHAP_OFFLINE__;
const BACKEND_URL = OFFLINE ? "" : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tkd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On an expired/invalid organizer session, drop the token and return to login.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      const p = window.location.pathname;
      if (p !== "/login" && p !== "/register") {
        localStorage.removeItem("tkd_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

function currentLang() {
  const saved = localStorage.getItem("lang");
  return saved && T["err.generic"][saved] ? saved : "it";
}

function interpolate(str, vars) {
  if (!vars) return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : `{${k}}`));
}

// Translate a backend error code like "err.pool_not_found" or "err.judges_not_ready|2/3".
function translateCode(detail) {
  const [code, param] = detail.split("|");
  const entry = T[code];
  if (!entry) return detail;
  const lang = currentLang();
  return interpolate(entry[lang] || entry.it || entry.en || code, param != null ? { n: param } : null);
}

export function formatApiError(detail) {
  if (detail == null) return translateCode("err.generic");
  if (typeof detail === "string") {
    if (detail.startsWith("err.")) return translateCode(detail);
    return detail;
  }
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
